import {API_URL, apiGetV1} from '../api'
import {ApiRes} from '../../types/api'

export interface IInvoiceData {
    month_amount: number
    month_count: number
    month_paid_amount: number
    month_paid_count: number
    over_due_amount: number
    over_due_count: number
    paid_amount: number
    paid_count: number
    today_amount: number
    today_count: number
    today_paid_amount: number
    today_paid_count: number
    total_amount: number
    total_count: number
    unpaid_count: number
    when: number
}

export const getInvoiceData = async (): Promise<ApiRes<IInvoiceData>> => {
    return await apiGetV1(API_URL, `admin/invoice_data`)
}
